import {
  Card,
  Grid,
  GridBreak,
  Stack,
  Typography,
  pn,
  replaceSpacesWithUnderscores,
} from "@compass/core";
import { DevExpressReport, renderReportColumn, renderReportSummary } from "components";
import { AprEtsTabIVE as AprResponseModel, ModelPropertyBase, ReportPropertyBase } from "generated/openApi";
import "moment-timezone";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

export const AprEtsTabIVE = (props: {
  data: AprResponseModel | undefined;
  totalTabA: number | undefined;
  properties: ModelPropertyBase[] | undefined;
}) => {
  const appTenantName = useSelector((state: RootState) => state.app.tenantName);
  const onExporting = () => {
    return {
      header: "PSE-IV.E",
      filename: replaceSpacesWithUnderscores("PSE-IV.E"),
      tenantName: appTenantName,
    };
  };

  return (
    <Card style={{ height: "100%" }}>
      <Stack spacing="sm" style={{ height: "100%" }}>
        <Typography variant="h5">Postsecondary Education Enrollment</Typography>
        <Grid container spacing="lg" maxWidth="1000px">
          <Grid item xs={4} alignItems="center" display="flex" justifyContent={"center"}>
            <Stack spacing="md" justifyContent={"center"} alignItems="center">
              <Typography variant="body1" textAlign={"center"}>
                Graduates
              </Typography>
              <Typography variant="h6">{props.data?.graduates}</Typography>
            </Stack>
          </Grid>

          <Grid item xs={4} alignItems="center" display="flex" justifyContent={"center"}>
            <Stack spacing="md" justifyContent={"center"} alignItems="center">
              <Typography variant="body1" textAlign={"center"}>
                Summer/Fall Enrollment
              </Typography>
              <Typography variant="h6">{props.data?.totalEnrollment}</Typography>
            </Stack>
          </Grid>

          <Grid item xs={4} alignItems="center" display="flex" justifyContent={"center"}>
            <Stack spacing="md" justifyContent={"center"} alignItems="center">
              <Typography variant="body1" textAlign={"center"}>
                Summer/Fall Enrollment %
              </Typography>
              <Typography variant="h6">{props.data?.totalEnrollmentPercent}%</Typography>
            </Stack>
          </Grid>

          <GridBreak />

          <Grid item xs={12}>
            <DevExpressReport
              title="Students"
              dataSource={props.data?.projectIdentifiers?.rows}
              exportFormats={["pdf", "excel", "csv"]}
              onExporting={onExporting}
              showColumnChooser={false}
            >
              {props.data?.projectIdentifiers?.properties?.map((property) =>
                renderReportColumn({
                  property: property,
                  propertyKey: pn<ReportPropertyBase>("propertyName"),
                })
              )}

              {renderReportSummary({
                properties: props.data?.projectIdentifiers?.properties,
                propertyKey: pn<ReportPropertyBase>("propertyName"),
                hideLabel: true,
              })}
            </DevExpressReport>
          </Grid>
        </Grid>
      </Stack>
    </Card>
  );
};
